/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EditSeminarScheduleSeminarScheduleFragmentDoc } from './EditSeminarSchedule.generated';
export type SeminarCalendarScheduleFragment = { id: string, startedAt: TimeString, endedAt: TimeString, applicantCount: number, isReachedCapacity: boolean, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString };

export const SeminarCalendarScheduleFragmentDoc = gql`
    fragment SeminarCalendarSchedule on Schedule {
  id
  startedAt
  endedAt
  applicantCount
  isReachedCapacity
  ...EditSeminarScheduleSeminarSchedule
}
    ${EditSeminarScheduleSeminarScheduleFragmentDoc}`;